module.exports = __webpack_public_path__ + "img/Majungasaurus_Thumb.e9d2058c.webp";